export const enumMap = Object.freeze({
  PENDENTE: "PENDENTE",
  ERRO: "ERRO",
  AGUARDANDO_PAGAMENTO: "AGUARDANDO_PAGAMENTO",
  PAGO: "PAGO",
  PROCESSADO: "PROCESSADO",
  CANCELADO: "CANCELADO",
  INADIMPLENTE: "INADIMPLENTE",
});

export const statusMap = Object.freeze({
  [enumMap.PENDENTE]: "bg-info-custom text-white",
  [enumMap.ERRO]: "bg-danger text-white",
  [enumMap.AGUARDANDO_PAGAMENTO]: "bg-warning text-white",
  [enumMap.PAGO]: "bg-primary text-white",
  [enumMap.PROCESSADO]: "bg-success text-white",
  [enumMap.CANCELADO]: "bg-danger text-white",
  [enumMap.INADIMPLENTE]: "bg-secondary text-white",
});

export const labelMap = Object.freeze({
  [enumMap.PENDENTE]: "Pendente",
  [enumMap.ERRO]: "Erro",
  [enumMap.AGUARDANDO_PAGAMENTO]: "Aguardando pagamento",
  [enumMap.PAGO]: "Pago",
  [enumMap.PROCESSADO]: "Processado",
  [enumMap.CANCELADO]: "Cancelado",
  [enumMap.INADIMPLENTE]: "Inadimplente",
});

/**
 * @param {keyof enumMap} value
 */
export function getParsedStatus(value) {
  const currentStatus = statusMap[value] || statusMap[enumMap.ERRO];
  const currentLabel = labelMap[value] || labelMap[enumMap.ERRO];

  return {
    class: currentStatus,
    label: currentLabel,
  };
}
